import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from './en';
import arLocale from './ar';
import daLocale from './da';
import nlLocale from './nl';


Vue.use(VueI18n);

const messages = {
  english: {
    ...enLocale
  },
  arabic: {
    ...arLocale
  },
  danish: {
    ...daLocale
  },
  dutch: {
    ...nlLocale
  }
};
const i18n = new VueI18n({
 
  locale: '',
  messages
});

export default i18n;
